import { render, staticRenderFns } from "./WebsiteManagePosts.vue?vue&type=template&id=06cebf26"
import script from "./WebsiteManagePosts.vue?vue&type=script&lang=js"
export * from "./WebsiteManagePosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports